import type { ReactNode } from 'react';
import { Typography, useTheme } from '@mui/material';

import { theme as tgTheme } from '@theguarantors/tg-package-material-ui';

type FieldHelperTextProps = {
  text?: ReactNode;
  disabled?: boolean;
};

export const FieldHelperText = ({ text, disabled = false }: FieldHelperTextProps) => {
  const theme = useTheme();

  return (
    <Typography
      sx={{
        color: disabled ? tgTheme.palette.neutralGrey[300] : theme.palette.grey[700],
        lineHeight: '20px',
        marginTop: '3px',
        padding: '0 16px',
      }}
      variant="helpertext"
    >
      {text}
    </Typography>
  );
};
